module.exports = __webpack_public_path__ + "img/esporodoquio 1.a7090128.webp";